<template>
  <div id="videoLcps"  v-if="subType == 'lcps'">
    <video ref="rtcVideoID" id="rtcVideoID" preload="auto" controls autoplay></video>
  </div>
  <div id="MPSplayer" v-else></div>
</template>

<script>
export default {
    name: 'PlayerTool',
    data() {
        return {
            player: null,
            subType: '',
            playTimer: null,
            playerLoadedTimer: null,
            initTimer: null,
            type:''
        }
    },
    mounted() {
        this.subType = window.EL.subType
        if(this.subType != 'lcps'){
          // https://sf1-hscdn-tos.pstatp.com/obj/media-fe/xgplayer_doc_video/flv/xgplayer-demo-480p.flv
          const url = window.EL.videoUrl
          this.init(url)
        }else{
          this.$nextTick(()=>{ this.loadConfig()})
        }
    },
    methods: {
        /* eslint-disable */
        init(url){
          const _this = this;
        // eslint-disable-next-line no-undef
        var mpsVideoPlayer =  new mpsPlayer({
            container: "MPSplayer",
            uin: "1011", //用户ID
            appId: "fumBub1N6zNQxQUx", //播放实例ID
            url,
            muted: false,
            width:'100%',
            height:'100%',
            autostart: true,
            enablehtml5: true, //是否优先使用H5播放器，默认为false
            isHideStep: false,
            onReady: function(){
              setTimeout(function(){
                mpsVideoPlayer.setMute(false);
                mpsVideoPlayer.startPlay()
              }, 2000)
            },
            });
            },
        loadConfig(){
          this.$nextTick(()=>{
            const url = window.EL.videoUrl
            new LcpsPlayerInit(url,()=>{
              this.loadVideo(url)
            })
          })
        },
        loadVideo(url){
          const stream =  "allpreview";
          const rtcVideoID = "rtcVideoID";
          const flashVideoID = "flashVideoID";
          const width = "100%";
          const height = "100%";
          const type = "auto";
          new LcpsPlayer(
            url.replace("http:", "")
               .replace("https:", ""),// 去除地址自带的双斜杠，因为内部会主动拼合
            stream,
            rtcVideoID,
            flashVideoID,
            width,
            height,
            type,
            () => {
            },
            this.loadPlay()
          );
          if (this.playerLoadedTimer) clearInterval(this.playerLoadedTimer);
          this.playerLoadedTimer = window.setInterval(() => {
            const isPlayerShown = document.getElementById("rtcVideoID").style.display !== "none";
            if (isPlayerShown) {
              this.loading = false;
              clearInterval(this.playerLoadedTimer);
            }
          }, 500);
        },
        loadPlay(){
          const player = document.getElementById("rtcVideoID");
          if (player) {
            if (player.paused) {
              if (this.playTimer) clearInterval(this.playTimer);
              this.playTimer = window.setInterval(() => {
                const playPromise = player.play();
                if (playPromise !== undefined) {
                  playPromise
                    .then(() => {
                      if (!player.paused) {
                        clearInterval(this.playTimer);
                      }
                    })
                    .catch(() => {
                    });
                }
              }, 500);
            } else {
              if (this.playTimer) clearInterval(this.playTimer);
            }
          }
        }
    }
}
</script>
<style lang="less" scoped>
 #MPSplayer,#videoLcps{
    width: 100%;
    height: 100%;
}
</style>>
